require('./dist/angular-ui-tree');
module.exports = 'ui.tree';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-tree/index.js
// module id = 394
// module chunks = 3